import {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {NavLink, useLocation} from 'react-router-dom';

import {Col, Row} from 'antd';
import {PageHeader} from '@ant-design/pro-components';

import classNames from 'classnames';

import useIsMobile from '@hooks/useIsMobile/useIsMobile';

import InfoPopoverIcon from '../../Common/InfoPopoverIcon/InfoPopoverIcon';
import {ExtendedRoutingContext} from '../../ExtendedRouting/ExtendedRoutingProvider';
import BasePageHeaderSubtitle from './BasePageHeaderSubtitle/BasePageHeaderSubtitle';

import './BasePageHeader.css';

function checkIfShorten(list, currentIndex) {
  let shorten = false;
  for (let i = currentIndex + 1; i < list.length; i++) {
    if (list[i].breadcrumbShortenAncestors === true) {
      shorten = true;
    }
  }
  return shorten;
}

function BasePageHeader(props) {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const location = useLocation();
  const extendedRoutingContext = useContext(ExtendedRoutingContext);
  const isMobile = useIsMobile();

  const {
    title,
    subtitle,
    subtitleExtra,
    info,
    heading,
    defaultTitle,
    extra,
    tabs,
    content,
    popoverPlacement,
    maxWidthPopover,
  } = props;

  function breadcrumbRenderer(route, _params, routes) {
    const last = routes.indexOf(route) === routes.length - 1;

    return last ? <span>{route.title}</span> : <NavLink to={route.path}>{route.title}</NavLink>;
  }

  function GetBreadcrumbParams() {
    if (breadcrumbs && breadcrumbs.length > 0) {
      return {
        items: breadcrumbs.map((item, currentIndex) => {
          const shorten = checkIfShorten(breadcrumbs, currentIndex);
          if (typeof item.breadcrumb === 'object' && item.breadcrumb !== null) {
            return {
              title:
                shorten && item.shortBreadcrumb ? (
                  <FormattedMessage {...item.shortBreadcrumb} />
                ) : (
                  <FormattedMessage {...item.breadcrumb} />
                ),
              path: item.url,
            };
          }
          return {
            title: item.breadcrumb,
            path: item.url,
          };
        }),
        itemRender: breadcrumbRenderer,
      };
    } else {
      return heading ? {items: [{title: heading, path: 'empty'}], itemRender: breadcrumbRenderer} : undefined;
    }
  }

  useEffect(() => {
    setBreadcrumbs([...extendedRoutingContext]);
  }, [extendedRoutingContext, setBreadcrumbs, location]);

  const hasSubtitle = !!subtitle;
  const hasSubtitleExtra = !!subtitleExtra;
  const hasMultipleBreadcrumbs = breadcrumbs && breadcrumbs.length > 1;

  return (
    <PageHeader
      className={classNames({'has-tabs': !!tabs, 'compact-breadcrumb': hasMultipleBreadcrumbs})}
      title={
        <Row style={{alignItems: 'baseline', display: 'flex'}}>
          <Col className={classNames('page-title', {'has-subtitle': hasSubtitle})}>{title || defaultTitle}</Col>
          {hasSubtitle ? (
            <Col className="page-header-subtitle">
              <BasePageHeaderSubtitle subtitle={subtitle} />
            </Col>
          ) : null}
          {hasSubtitleExtra ? <Col>{subtitleExtra}</Col> : null}
        </Row>
      }
      subTitle={
        <>
          {info && (
            <InfoPopoverIcon
              maxWidth={maxWidthPopover || (isMobile ? 'calc(100vw - 32px)' : undefined)}
              content={info}
              placement={popoverPlacement || (isMobile ? 'bottom' : undefined)}
            />
          )}
        </>
      }
      extra={extra}
      breadcrumb={GetBreadcrumbParams()}
      footer={tabs && tabs}
    >
      {content}
    </PageHeader>
  );
}

BasePageHeader.propTypes = {
  title: PropTypes.node,
  info: PropTypes.node,
  subtitle: PropTypes.node,
  subtitleExtra: PropTypes.node,
  heading: PropTypes.node,
  defaultTitle: PropTypes.node,
  extra: PropTypes.node,
  tabs: PropTypes.node,
  content: PropTypes.node,
  popoverPlacement: PropTypes.string,
  maxWidthPopover: PropTypes.string,
};

export default BasePageHeader;
